import React from "react";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { NotFound } from "./components/NotFound";
import { OpenPaymentLink } from "./OpenPaymentLink";
import { PymePaymentLink } from "./PymePaymentLink";
import { PymeOpenPaymentLink } from "./PymeOpenPaymentLink";
import { RegisterRequest } from './RegisterRequest'
import { RegisterRequestPyme } from './RegisterRequestPyme'


export const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route
            exact
            path="/payment-link/:slug/"
            element={<OpenPaymentLink />}
        />
        <Route
            exact
            path="/pyme/:tenant/:uuid/"
            element={<PymePaymentLink />}
        />

        <Route
            exact
            path="/pyme/:tenant/"
            element={<PymeOpenPaymentLink />}
        />

        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />

        <Route
            exact
            path="/solicitar/"
            element={<RegisterRequest />}
        />
        <Route
            exact
            path="/solicitar-pyme/"
            element={<RegisterRequestPyme />}
        />

      </Routes>
    </Router>
  );
};